export default "__VITE_ASSET__CfWbfh4p__"